import { FOCUSABLES_SELECTOR, isElementFocusable } from './is-focusable';

let modalIndex = 10;
export default function toggleElement( elementOrId, show, focus ) {
	if ( ! elementOrId ) {
		return;
	}

	let target, targetId;
	if ( typeof elementOrId === 'string' ) {
		targetId = elementOrId;
		target = document.getElementById( targetId );
	} else {
		target = elementOrId;
		targetId = target.id;
	}

	if ( ! target ) {
		return;
	}

	// Get the controls for this element
	const controls = document.querySelectorAll( `[aria-controls="${ targetId }"]` );

	if ( typeof show === 'undefined' || show === null ) {
		// Toggle based on target's hidden status
		show = target.getAttribute( 'aria-hidden' ) === 'true' || target.getAttribute( 'aria-hidden' ) !== 'false';
	}

	// Update the controls if applicable
	controls.forEach( control => {
		if ( control.hasAttribute( 'aria-expanded' ) ) {
			control.setAttribute( 'aria-expanded', show );
		}
		if ( control.hasAttribute( 'aria-selected' ) ) {
			control.tabIndex = show ? null : -1;
			control.setAttribute( 'aria-selected', show );
		}
	} );

	// Hide/show the target
	target.setAttribute( 'aria-hidden', ! show );
	if ( show && focus ) {
		if ( target.getAttribute( 'role' ) === 'dialog' ) {
			// If it's a modal, update the z-index to the next level up
			target.style.zIndex = ++modalIndex;
		}

		const autofocus = [ ...target.querySelectorAll( '[autofocus]' ) ].find( isElementFocusable );

		// If target contains an autofocus element, focus that
		if ( autofocus ) {
			autofocus.focus();
		} else
		// If target itself is meant to be focused (is tabble or has explicit tabindex)
		if ( target.tabIndex > 0 || target.hasAttribute( 'tabindex' ) ) {
			target.focus();
		} else {
			// Find the first focusable element within and focus that
			const focusable = [ ...target.querySelectorAll( FOCUSABLES_SELECTOR ) ].find( isElementFocusable );
			if ( focusable ) {
				focusable.focus();
			}
		}
	}

	// Trigger event for target ID
	const event = new CustomEvent( `toggle-${ show ? 'on' : 'off' }` );
	target.dispatchEvent( event );

	return show;
}
